export const sanityProjectId = 'czqk28jt';
export const sanityStage = process.env.REACT_APP_RBI_ENV ?? 'dev';
export const sanityRegion = process.env.REACT_APP_RBI_COUNTRY ?? 'us';

export const sanityDataset = `${sanityStage}_fhs_${sanityRegion}`;
